import { useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { Cargando } from '../../../../components/layout/Cargando'
import ComponentePrivado from '../../../../components/roles/ComponentePrivado'
import { RootState } from '../../../../redux'
import { useRecuperarTareasPorIdRelacionadoMutation } from '../../../../redux/api'
import { cargarTareas } from '../../../../redux/slices/tareas'
import { AppConstantes, AppMapas } from '../../../../utils/Constantes'
import dayjs from '../../../../utils/DayjsUtil'
import { esTareaPorVencer } from '../../../../utils/EsTareaPorVencer'
import { Roles } from '../../../../utils/Roles'
import ModalTareaCompletada from '../../../tareas/components/ModalTareaCompletada'
import { Tarea } from '../../../tareas/models'
import { Condicionante } from '../../models'
import { InputBusquedaFiltrado } from './InputBuscar'

type Props = {
  condicionanteSeleccionada?: Condicionante
  setCondicionanteSeleccionada: (arg: Condicionante | undefined) => void
  setTareaSeleccionada: (arg: Tarea) => void | null
  claveNivel: string //AUTORIZACION, CONDICIONANTE
  setClaveNivel: (arg: string) => void
  idSeleccionado: string
  setIdSeleccionado: (arg: string) => void
  idAutorizacion?: string
  idAutorizacionSeleccionada: string
  idCondicionanteSeleccionada: string
  mostrarModalTarea: boolean
  setMostrarModalTarea: (arg: boolean) => void
  isSuccessGuardar?: boolean
  isSuccessActualizar?: boolean
  isSuccessRecuperarAutorizacion: boolean
  setIsModoEditar: (arg: boolean) => void
}

export const DetalleAutorizacionCardTareas = ({
  idAutorizacion,
  condicionanteSeleccionada,
  setCondicionanteSeleccionada,
  claveNivel,
  setTareaSeleccionada,
  setMostrarModalTarea,
  setIdSeleccionado,
  setClaveNivel,
  setIsModoEditar,
  idSeleccionado,
  isSuccessRecuperarAutorizacion,
  idAutorizacionSeleccionada,
  idCondicionanteSeleccionada,
  mostrarModalTarea,
  isSuccessActualizar,
  isSuccessGuardar,
}: Props) => {
  const dispatch = useDispatch()
  const [recuperarTareas, { isSuccess, isLoading }] = useRecuperarTareasPorIdRelacionadoMutation()

  const tareasRecuperadas = useSelector((state: RootState) => state.listaTareas)

  const tareasExistentes = tareasRecuperadas.tareas.map((r: Tarea) => {
    return {
      idTarea: r.idTarea,
      idSitio: r.idSitio,
      idAutorizacion: r.idAutorizacion,
      titulo: r.titulo,
      idUsuarioAsignado: r.idUsuarioAsignado,
      nombreUsuarioAsignado: r.nombreUsuarioAsignado,
      fechaInicio: r.fechaInicio,
      fechaTermino: r.fechaTermino,
      descripcion: r.descripcion,
      estatus: r.estatus,
      descEstatus: r.descEstatus,
    }
  }) as []
  const [tareasFiltradas, setTareasFiltradas] = useState<Tarea[]>()
  const [palabraInputBusquedaTarea, setPalabraInputBusquedaTarea] = useState('')
  const [filtroActivo, setFiltroActivo] = useState(false)
  const [idTarea, setIdTarea] = useState('')
  const [mostrarModalComentario, setMostrarModalComentario] = useState(false)

  useEffect(() => {
    // Carga tareas según el nivel seleccionado:
    // - `autorizacion/<id>` => tareas de la autorización
    // - `condicionante/<id>` => tareas de la condicionante
    // Limpia filtros/búsqueda al cambiar el nivel.
    if (isSuccessRecuperarAutorizacion && claveNivel === 'autorizacion') {
      recuperarTareas(idAutorizacionSeleccionada)
        .unwrap()
        .then((resp: Tarea[]) => {
          dispatch(cargarTareas(resp))
        })
        .catch(console.error)
      borrarFiltroTarea()
    }
    if (isSuccessRecuperarAutorizacion && claveNivel === 'condicionante') {
      recuperarTareas(idCondicionanteSeleccionada)
        .unwrap()
        .then((resp: Tarea[]) => {
          dispatch(cargarTareas(resp))
        })
        .catch(console.error)
      borrarFiltroTarea()
    }

    if (!isSuccess || isLoading) {
      // Evita renderizar tareas antiguas mientras se recupera nuevo conjunto.
      dispatch(cargarTareas([]))
    }
  }, [
    isSuccessRecuperarAutorizacion,
    claveNivel,
    idSeleccionado,
    idCondicionanteSeleccionada,
    mostrarModalTarea,
    isSuccessActualizar,
    isSuccessGuardar,
  ])
  /**
   * @description Abre el modal de nueva tarea relacionada
   *              a la auotrización
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 09/11/2022
   */
  const agregarNuevaTarea = () => {
    setMostrarModalTarea(true)
  }

  /**
   * @description  Cierre de tarjeta "Tareas condicionante" y apertura
   *               de "Tareas Autorización"
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 25/10/2022
   */
  const cerrarTareasCondicionante = () => {
    setClaveNivel(AppConstantes.CLAVE_NIVEL_AUTORIZACION)
    setClaveNivel('autorizacion')
    setIdSeleccionado(`autorizacion/${idAutorizacion}`)
  }

  /**
   * @description Cambia el estilo al seleccionar tarea,
   *              los botones de edición y pasa los datos de la tarea
   *              seleccionada al estado.
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 14/11/2022
   * @param tarea Objeto de tarea seleccionada.
   */
  const editarTarea = (tarea: Tarea) => {
    setTareaSeleccionada(tarea)
    setIsModoEditar(true)
    setMostrarModalTarea(true)
  }

  /**
   * @description borra la palabra ingresada en la busqueda de  tareas
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 21/02/2023
   */
  const borrarFiltroTarea = () => {
    setPalabraInputBusquedaTarea('')
    setFiltroActivo(false)
  }

  /**
   * @description Abre modal con comentario de cierre de tarea completada seleccionada,
   *              y pasa el id de la tarea.
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 31/05/2023
   * @param tarea Objeto de la tarea seleccionada
   */
  const mostrarModalTareaComentario = (tarea: Tarea) => {
    setIdTarea(tarea.idTarea)
    setMostrarModalComentario(true)
  }


  /**
   * @description Genera el hearder con el nombre de la
   *              condicionante seleccionada y cantidad
   *               de tarea.
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 01/06/2023
   * @returns header de las tareas con la condicionante
   *          seleccionada
   */
  const headerCard = () => {
    return (
      <div className='div-titulo-cards'>
        <div className='align-items-center d-flex flex-grow-1 '>
          <h3 className=' d-flex'>Tareas</h3>
          <span className='text-muted fw-lighter fs-4 ps-2 d-flex'>
            | {(tareasFiltradas && filtroActivo ? tareasFiltradas : tareasExistentes).length} total
          </span>{' '}
        </div>
        {condicionanteSeleccionada ? <p>{condicionanteSeleccionada.nombre}</p> : ''}
      </div>
    )
  }

  return (
    <>
      {mostrarModalComentario && (
        <ModalTareaCompletada
          cerrarModal={() => setMostrarModalComentario(false)}
          mostrarModal={mostrarModalComentario}
          tareaId={idTarea}
        />
      )}
      <div id='collapseContactos' className='col-4 '>
        <div className='card  condicionantes-autorizacion card-height'>
          <div className='card-header align-items-center pe-3 px-3 mx-0 '>
            {headerCard()}
            <div className=' d-flex justify-content-end'>
              <div className='pl-17'>
                <ComponentePrivado rolMostrarPorPermiso={[Roles.roleTareasCrear]}>
                  <OverlayTrigger placement={'top'} overlay={<Tooltip>Agregar</Tooltip>}>
                    <button
                      className='btn btn-outline-primary btn-icon btn-circle btn-sm'
                      type='button'
                      onClick={() => {
                        agregarNuevaTarea()
                      }}>
                      <i className='fa-solid fa-plus fs-1'></i>
                    </button>
                  </OverlayTrigger>
                </ComponentePrivado>
              </div>
              {condicionanteSeleccionada && claveNivel === 'condicionante' ? (
                <div className=''>
                  <OverlayTrigger placement={'top'} overlay={<Tooltip>Cerrar</Tooltip>}>
                    <button
                      className='btn btn-outline-dark btn-icon btn-circle btn-sm d-flex'
                      type='button'
                      data-bs-toggle='tooltip'
                      data-bs-placement='left'
                      onClick={() => {
                        cerrarTareasCondicionante()
                        setIdSeleccionado(`autorizacion/${idAutorizacion}`)
                        setCondicionanteSeleccionada(undefined)
                      }}>
                      <i className='fa-solid fa-xmark fs-1 '></i>
                    </button>
                  </OverlayTrigger>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <InputBusquedaFiltrado
            arregloObjetos={tareasExistentes ? tareasExistentes : []}
            setArregloObjetosFiltrados={setTareasFiltradas}
            tipo={AppConstantes.CVE_INPUT_TAREA}
            setFiltroActivo={setFiltroActivo}
            palabraInputBusqueda={palabraInputBusquedaTarea}
            setPalabraInputBusqueda={setPalabraInputBusquedaTarea}
            borrarFiltroTarea={borrarFiltroTarea}></InputBusquedaFiltrado>
          {(tareasFiltradas && filtroActivo ? tareasFiltradas : tareasExistentes).length === 0 ? (
            <div style={{ marginTop: '25vh' }}>
              {isSuccess ? (
                <>
                  <div className=' d-flex justify-content-center ms-5 '>
                    <i className=' bi bi-book font-size-icon'></i>
                  </div>
                  <div className='d-flex justify-content-center ms-5 mt-2'>
                    <i style={{ fontSize: '1.2em' }}>Sin tareas</i>
                  </div>
                </>
              ) : (
                <Cargando mensaje='Recuperando tareas'></Cargando>
              )}
            </div>
          ) : (
            <div className='overflow-auto'>
              {(tareasFiltradas && filtroActivo ? tareasFiltradas : tareasExistentes)?.map(
                (tarea: Tarea, i: number) => (
                  <div
                    key={i}
                    className='d-flex flex-column px-4 pt-4  hover-overlay bg-hover-light-secondary pt-4 pb-4'
                    onClick={() => {
                      editarTarea(tarea)
                      setTareaSeleccionada(tarea)
                    }}>
                    <div
                      className='d-flex justify-content-between'
                      onClick={() => {
                        editarTarea(tarea)
                      }}>
                      <div className='pt-2'>
                        <h4 className='d-flex align-items-center text-hover fs-4'>
                          {tarea.titulo}
                        </h4>
                      </div>

                      <div className='text-end w-50'>
                        <p className='fs-4 nombre-user-card-tarea'>
                          <i className='fa-solid fa-user text-dark me-2'></i>
                          {tarea.nombreUsuarioAsignado}
                        </p>
                      </div>
                    </div>

                    <div className='d-flex flex-column flex-fill me-0 my-2 fs-5'>
                      <p className='text-gray-800'>{tarea.descripcion}</p>
                    </div>
                    <div className='flex-fill me-0 fs-5  mt-2 d-flex justify-content-between'>
                      <p className=' fw-semibold text-gray-600 text-start'>Estatus </p>
                      <div className='justify-content-end'>
                        <span
                          className={`fs-7 mx-0 text-end badge ms-2 text-wh badge-${
                            tarea.estatus === AppConstantes.CVE_ESTATUS_TAREA_EN_PROCESO &&
                            esTareaPorVencer(tarea.fechaTermino)
                              ? 'light-warning'
                              : AppMapas.MAPA_ESTATUS_TAREAS.get(tarea.estatus) ?? 'light-dark'
                          } badge-lg fw-bold px-3 py-2`}
                          onClick={(e) => {
                            e.stopPropagation()
                            mostrarModalTareaComentario(tarea)
                          }}
                          style={{
                            cursor: `${
                              tarea.estatus === AppConstantes.CVE_ESTATUS_TAREA_COMPLETADA
                                ? 'pointer'
                                : 'default'
                            }`,
                          }}>
                          {/*
                            UX: el estatus funciona como “disparador” de ver comentario/evidencia
                            únicamente cuando la tarea está COMPLETADA.
                          */}
                          {tarea.estatus === AppConstantes.CVE_ESTATUS_TAREA_COMPLETADA && (
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>Ver comentario de cierre.</Tooltip>}>
                              <button
                                className='btn btn-active-color-success-active btn-color-success p-1 mb-1'
                                type='button'
                                onClick={(e) => {
                                  e.stopPropagation()
                                  mostrarModalTareaComentario(tarea)
                                }}>
                                <i className='fa-solid fa-file-invoice fs-3'></i>
                              </button>
                            </OverlayTrigger>
                          )}
                          {AppMapas.MAPA_ESTATUS_TAREA_DESCRIPCIONES.get(tarea.estatus)}
                        </span>
                      </div>
                    </div>

                    <div className='flex-fill me-0  mt-1  d-flex justify-content-between'>
                      <p className=' fw-semibold text-gray-600 fs-5'>Fecha de inicio</p>
                      <p className='fw-bold  text-gray-700  fs-5'>
                        {dayjs(tarea.fechaInicio).format('DD/MMM/YYYY')}
                      </p>
                    </div>
                    <div className='flex-fill me-0  mt-1  d-flex justify-content-between'>
                      <p className=' fw-semibold text-gray-600 fs-5'>Fecha de término</p>
                      <p className='fw-bold  text-gray-700 fs-5 '>
                        {dayjs(tarea.fechaTermino).format('DD/MMM/YYYY')}
                      </p>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
